import React, { useRef, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import './styles.css'
import { useFilter } from "../../lib/varFilter";
import rootDir from "../..";
import { useHeader } from "../../lib/varHeader";

const SearchBar = () => {
    const { setFilter } = useFilter();
    const { setHeader } = useHeader();
    const searchRef = useRef<HTMLInputElement>(null);
    const [searcher, setSearcher] = useState<string>("");

    function setSearch() {
        const filter = {
            q: searcher,
        }
        const header = {
            current_loaded_page: 0,
        }
        setHeader((prev) => ({ ...prev, ...header}))
        setFilter((prev) => ({ ...prev, ...filter}))
    }
    function clearSearch() {
        const filter = {
            q: '',
        }
        const header = {
            current_loaded_page: 0,
        }
        setHeader((prev) => ({ ...prev, ...header}))
        setFilter((prev) => ({ ...prev, ...filter}))
        setSearcher('')
    }
    const pressEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            setSearch();
            // setSearch() => redirect(rootDir+'page/1');
            // <Navigate to={rootDir+'page/1'} />
            // <Redirect to={rootDir+'page/1'} push/>
            // => return redirect(rootDir+'page/1');
        }
    }
    // console.log(searcher)
    return (
        <div className="searchBox">
            <input 
                className="input_box" 
                ref={searchRef}
                value={searcher} 
                onChange={(e) => setSearcher(e.target.value)} 
                onKeyDown={pressEnter}
                type='text' 
                placeholder='Search'
            />
            <Link to={rootDir+'page/1'}>
                <button 
                className="input_submit" 
                type='submit'
                onClick={function() {setSearch();}}
                onSubmit={function() {setSearch();}}
                // on
                    >Go</button>
            </Link>
            <Link to={rootDir+'page/1'}>
                <button
                className="clear_submit"
                type='submit'
                onClick={function() {clearSearch();}}
                    >X</button>
            </Link>
        {/* // </form> */}
        </div>
    )
}

export default SearchBar